import { LicensingAgencyDocumentType } from '@/@types/generated'
import { register } from './enum'

export const LicensingAgencyDocumentTypeLabels: Record<
  LicensingAgencyDocumentType,
  string
> = {
  [LicensingAgencyDocumentType.EIN_CONFIRMATION_LETTER]:
    'EIN Confirmation Letter',
}

register<LicensingAgencyDocumentType>(LicensingAgencyDocumentType, (v) => {
  if (!v) return '\u2014'
  return LicensingAgencyDocumentTypeLabels[v]
})
